import { createSelector, Selector } from "@ngxs/store";
import { SelectedVariablesState, SelectedVariablesStateModel } from "./selected-variables.state";
import { VariablesState, VariablesStateModel } from "../variables/variables.state";
import { SelectedVariablesSortEnum } from "../../interfaces/selected-variables-sort.enum";

export class SelectedVariablesGetterState {
  @Selector([SelectedVariablesState])
  static getSelectedVariables(state: SelectedVariablesStateModel) {
    return state.tags;
  }

  static getSortedSelectedVariables(sort: string) {
    return createSelector(
      [SelectedVariablesState, VariablesState],
      (selectedVariablesState: SelectedVariablesStateModel, variablesState: VariablesStateModel) => {
      const tags = selectedVariablesState.tags;
      if (sort === SelectedVariablesSortEnum.alphabetically) {
        const tagInfo = variablesState.tagInfo;
        const variables = tags.map(tag => ({
          tag: tag,
          label: tagInfo[tag]?.label || tag,
        }));
        return variables.sort((a, b) => a.label > b.label ? 1 : -1).map(v => v.tag);
      } else {
        return tags;
      }
    })
  }
}